var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('app-navigation'),_c('alert-dialog'),_c('filter-dialog'),_c('v-main',{staticClass:"flex"},[(!_vm.isLoading)?_c('router-view'):_c('v-container',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }